// extracted by mini-css-extract-plugin
export default {"group":"styles_group__4uBof","language":"styles_language__7rezk"};